import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const companyProfileService = {
  getAll, create, update, setPrimary, remove, getPresets, previewDesign, saveDesign,
}

const API_URL = API.BASE_URL + '/v1'

export function getAll() {
  return apiHelper(API_URL).get('/company-profiles')
}
export function getPresets() {
  return apiHelper(API_URL).get('/company-profiles/presets')
}
export function previewDesign(uuid, design) {
  return apiHelper(API_URL).post(`/company-profiles/${uuid}/preview`, { design_json: design })
}
export function saveDesign(uuid, design) {
  return apiHelper(API_URL).put(`/company-profiles/${uuid}/design`, { design_json: design })
}
export function create(data) {
  return apiHelper(API_URL).post('/company-profiles', data)
}
export function update(uuid, data) {
  return apiHelper(API_URL).put(`/company-profiles/${uuid}`, data)
}
export function setPrimary(uuid) {
  return apiHelper(API_URL).patch(`/company-profiles/${uuid}/primary`)
}
export function remove(uuid) {
  return apiHelper(API_URL).delete(`/company-profiles/${uuid}`)
}
